// header
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER'
// 屏幕大小改变
export const SCREEN_CHANGE = 'SCREEN_CHANGE'
// 显示右边面板
export const SHOW_RIGHT_NAV = 'SHOW_RIGHT_NAV'
// 是否是管理员页面
export const IS_ADMIN_WRAP = 'IS_ADMIN_WRAP'
// 管理员是否登录
export const IS_LOGIN = 'IS_LOGIN'
// 弹出重新登录提示
export const SHOW_TOKEN_ERROR = 'SHOW_TOKEN_ERROR'
// 保存管理员信息
export const SET_ADMIN_INFO = 'SET_ADMIN_INFO'
// 保存博客信息
export const SET_BLOG_INFO = 'SET_BLOG_INFO'
// 保存文章目录信息
export const SET_ARTICLE_MENU = 'SET_ARTICLE_MENU'
// 保存文章目录信息(未生成树的)
export const SET_ARTICLE_MENU_SOURCE = 'SET_ARTICLE_MENU_SOURCE'
// 保存当前为文章第几个目录
export const SET_ARTICLE_MENU_TAG = 'SET_ARTICLE_MENU_TAG'
// 保存评论填写的昵称邮箱信息
export const SET_COMMENTS_INFO = 'SET_COMMENTS_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js